import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function GTMPageView() {
    const location = useLocation();
    const lastPathRef = useRef(null);

    useEffect(() => {
        if (lastPathRef.current === location.pathname) {
            return;
        }
        lastPathRef.current = location.pathname;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "page_view",
            page_path: location.pathname,
        });
    }, [location]);

    return null;
}
